import { ReferentialDto, ReferentialKey } from "api/referential";
import { TenantDto } from "api/tenant";
import { TenantFormFieldNames } from "../types/tenantFormFieldNames";
import { TenantFormValues } from "../types/tenantFormValues";

/**
 * Convertit un TenantFormValues vers un TenantDto
 * @param formValues - Les valeurs du formulaire
 * @param civilityId - L'ID de civilité (requis car le form contient probablement le libellé)
 * @param employmentStatusId - L'ID du statut d'emploi (requis car le form contient probablement le libellé)
 * @param rgiId - L'ID RGI optionnel
 * @returns TenantDto
 */
export const mapTenantFormValues = (
  formValues: TenantFormValues,
  referentialsData: Record<ReferentialKey, ReferentialDto[]>,
): TenantDto => {

  const findReferentialId = (referentialType: ReferentialKey, code: string): string => {
    const item = referentialsData[referentialType]?.find((item: any) => item.code === code);
    return item?.id || '';
  };

  const mapIncomes = () => {
    const incomes = formValues[TenantFormFieldNames.Incomes]
    return incomes
      // Ligne résiduelle d'un locataire en place (section masquée, non validée) :
      // ne pas envoyer un revenu sans type ou sans montant au back.
      .filter((income) => income.incomeType && income.amount > 0)
      .map((income) => ({
        incomeTypeId: findReferentialId(ReferentialKey.IncomeType, income.incomeType),
        value: income.amount
      }))
  }

  return {
    id: formValues['id'] || undefined,
    lastName: formValues[TenantFormFieldNames.LastName],
    firstName: formValues[TenantFormFieldNames.FirstName],
    // Dates calendaires : string "yyyy-MM-dd" du picker de bout en bout
    birthDate: formValues[TenantFormFieldNames.BirthDate],
    phone: formValues[TenantFormFieldNames.Phone],
    email: formValues[TenantFormFieldNames.Email],
    guarantor: formValues[TenantFormFieldNames.Guarantor],
    civilityId: findReferentialId(ReferentialKey.Civility, formValues[TenantFormFieldNames.Civility]),
    // Vide pour un locataire en place (champ masqué) : ne rien envoyer plutôt qu'un uuid vide
    employmentStatusId: findReferentialId(ReferentialKey.EmploymentStatus, formValues[TenantFormFieldNames.ProfessionalSituation]) || undefined,
    checkInDate: formValues[TenantFormFieldNames.CheckInDate],
    checkOutDate: formValues[TenantFormFieldNames.CheckOutDate] || undefined,
    rentPaymentsUpToDate: formValues[TenantFormFieldNames.RentPaymentsUpToDate],
    incomes: mapIncomes()
  };
};

